import api from '../api';

function buildCategoryMap(categories) {
  if (!categories) return {};
  if (Array.isArray(categories)) {
    const map = {};
    for (const c of categories) {
      const id = String(c?.id ?? c?._key ?? c?.categoryId ?? c?.category ?? '');
      if (id) map[id] = c;
    }
    return map;
  }
  return categories;
}

function getCategoryName(catMap, catId, lang) {
  const c = catMap?.[String(catId)];
  if (!c) return '';
  return (c.singular?.[lang]) ?? c.singular?.eng ?? c.name ?? c.label ?? String(catId ?? '');
}

export async function fetchProduction (lang) {
  const [prodRes, catRes] = await Promise.all([
    api.getProduction(),
    api.getCategories().catch(() => ({ data: null }))
  ]);

  const production = prodRes.data || {};
  const catMap = buildCategoryMap(catRes.data);

  const data = Object.keys(production).map(key => {
    const movie = production[key] || {};
    const catId = movie.category ?? movie.categoryId ?? '';
    const category = getCategoryName(catMap, catId, lang);
    return Object.assign({}, movie, { category, categoryId: catId, id: key });
  });

  const parseYear = (y) => {
    const m = String(y ?? '').match(/\d+/);
    let v = m ? parseInt(m[0], 10) : 0;
    if (v < 50) v += 2000;
    else if (v < 100) v += 1900;
    return v;
  };

  data.sort((a, b) => {
    const yearA = parseYear(a.year);
    const yearB = parseYear(b.year);
    if (yearA === yearB) {
      const ta = (a.title?.eng || '').replace(/^The /i, '');
      const tb = (b.title?.eng || '').replace(/^The /i, '');
      return ta.localeCompare(tb);
    }
    return yearB - yearA;
  });

  return data;
}

export async function fetchMovie (key) {
  const production = (await api.getProduction()).data;
  return production[ key ];
}

export async function submitMovie (token, data) {
  let fd;
  if (data instanceof FormData) {
    fd = data; // fix: use data before appending
    if (!fd.has('type')) fd.append('type', 'movie');
    // ensure id is present (some backends expect "id" not "_key")
    if (!fd.has('id') && fd.get('_key')) fd.append('id', fd.get('_key'));
  } else {
    const m = data || {};
    const id = m._key || m.id;
    // prefer categoryId; fallback to numeric category; otherwise blank
    const numericCat = (v) => (typeof v === 'number' || /^\d+$/.test(String(v || ''))) ? String(v) : '';
    const categoryId = (m.categoryId != null) ? String(m.categoryId) : numericCat(m.category);

    fd = new FormData();
    fd.append('type', 'movie');
    if (id) { fd.append('id', id); fd.append('_key', id); }
    // image may be a File/Blob or empty string; backend decides how to handle
    if (m.image !== undefined) fd.append('image', m.image);
    fd.append('year', (m.year ?? '').toString());
    fd.append('runtime', (m.runtime ?? '').toString());
    fd.append('category', categoryId);
    fd.append('synopsis', m.synopsis || '');
    fd.append('title[eng]', m.title?.eng || '');
    fd.append('title[fin]', m.title?.fin || '');
    fd.append('people', JSON.stringify(m.people || { cast: [], crew: [] }));
  }
  const response = (await api.submitMovie(token, fd)).data;
  return response;
}

export async function deleteMovie (token, id) {
  let fd = new FormData();
  fd.append('type', 'movie');
  fd.append('id', id);
  let response = (await api.deleteMovie(token, fd)).data;
  return response;
}
